import { openBlock as r, createElementBlock as l, createElementVNode as o } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function n(a, e) {
  return r(), l("svg", t, [...e[0] || (e[0] = [
    o("path", {
      fill: "currentColor",
      d: "M13.078 21q-.816 0-1.16-.692-.342-.69.115-1.333L17.093 12l-5.06-6.975q-.457-.643-.114-1.335Q12.26 3 13.078 3q.359 0 .652.176.294.177.49.435l5.519 7.65q.13.16.196.353.065.193.065.386 0 .194-.065.369a1.7 1.7 0 0 1-.196.37l-5.519 7.65q-.196.258-.49.435a1.25 1.25 0 0 1-.652.176m-7.772 0q-.816 0-1.159-.692-.343-.69.114-1.333L9.322 12 4.261 5.025q-.458-.643-.114-1.335Q4.49 3 5.306 3q.36 0 .653.176.294.177.49.435l5.518 7.65q.131.16.196.353.066.193.066.386a1.2 1.2 0 0 1-.262.74L6.45 20.39q-.195.256-.49.434a1.25 1.25 0 0 1-.653.176"
    }, null, -1)
  ])]);
}
const c = { render: n };
export {
  c as default,
  n as render
};
